import ApiClient from "./ApiClient"

import TimeLimit    from "../types/TimeLimit"
import SyncResult   from "../types/SyncResult"

export const TimeLimitApi = {

    apiPath: 'time-limits',

    get: async (id: number, include?: string): Promise<TimeLimit> => {

        let url: string = TimeLimitApi.apiPath + '/' + id

        if (include) {
            url += `?include=${include}`
        }

        const response = await ApiClient.get(url)

        return response.data.data
    },

    getAll: async (search?: string): Promise<TimeLimit[]> => {
        const items: TimeLimit[] = []
        const params = new URLSearchParams([
            ['lockingSystemId', localStorage.getItem('selectedLockingSystemId') as string]
        ])

        if (search) params.append('search', search)

        const response = await ApiClient.get(TimeLimitApi.apiPath, { params });

        for (let item of response.data.data) {
            items.push(item)
        }

        return items
    },

    add: async (newTimeLimit: TimeLimit): Promise<TimeLimit> => {
        const result = await ApiClient.post(TimeLimitApi.apiPath, newTimeLimit);

        return result?.data.data
    },

    edit: async (timeLimit: TimeLimit): Promise<TimeLimit> => {
        const result = await ApiClient.put(TimeLimitApi.apiPath + '/' + timeLimit.id, timeLimit);

        return result?.data.data
    },

    delete: async(id: number): Promise<any> => {

        return await ApiClient.delete(TimeLimitApi.apiPath + '/' + id);

    },

    syncAllByLockingSystemId: async (lockingSystemId: number): Promise<SyncResult> => {
        const params = new URLSearchParams([['lockingSystemId', lockingSystemId.toString()]])

        const result = await ApiClient.get(TimeLimitApi.apiPath + '/sync/all', { params })

        return result?.data
    },

    syncItemById: async (item: TimeLimit, softSync: boolean): Promise<TimeLimit | void> => {
        if (item.lockingSystemId === undefined) return

        const params = new URLSearchParams([['lockingSystemId', item.lockingSystemId.toString()]])

        if (softSync) params.append('soft', softSync.toString())

        const result = await ApiClient.get('time-limits/sync/' + item.id, { params })

        return result?.data?.data
    }
}

export default TimeLimitApi